export default class QuizUtils {
  static isFirstQuizFeedbackVisible(step, totalQuestions) {
    const targetStep = Math.floor(totalQuestions * 0.25);
    return step === targetStep;
  }

  static isSecondQuizFeedbackVisible(step, totalQuestions) {
    const targetStep = Math.floor(totalQuestions * 0.5);
    return step === targetStep;
  }

  static isThirdQuizFeedbackVisible(step, totalQuestions) {
    const targetStep = Math.floor(totalQuestions * 0.75);
    return step === targetStep;
  }

  static isFourthQuizFeedbackVisible(step, questionsTotalNumber) {
    if (step === questionsTotalNumber - 1) return true;
    else return false;
  }

  static isQuizFeedbackVisible(step, questionsTotalNumber) {
    return (
      this.isFirstQuizFeedbackVisible(step, questionsTotalNumber) ||
      this.isSecondQuizFeedbackVisible(step, questionsTotalNumber) ||
      this.isThirdQuizFeedbackVisible(step, questionsTotalNumber) ||
      this.isFourthQuizFeedbackVisible(step, questionsTotalNumber)
    );
  }
}
